<template>
  <onboardingModal :step="3" :type="type">
    <template slot="body">
      <div class="d-flex flex-column align-items-center px-2">
        <div class="px-0 d-flex flex-column align-items-center w-100">

          <a v-if="type === 'wordpress'" target="_blank" href="https://wordpress.org/plugins/wallkit/">
            <b-btn class="py-2 mb-3 text-uppercase px-4 w-100" v-if="type">
              <i class="fab fa-wordpress fa-lg mr-2"></i>
              {{$t(`onboarding.${type}_integration`)}}
            </b-btn>
          </a>

          <a v-else target="_blank" href="https://github.com/wallkitnet/js-sdk">
            <b-btn class="py-2 mb-3 text-uppercase px-4 w-100" v-if="type">
              <i class="fab fa-github fa-lg mr-2"></i>
              {{$t(`onboarding.${type}_integration`)}}
            </b-btn>
          </a>

          <div v-if="type !== 'wordpress'" class="mb-3 mt-2">
            <span class="text-primary mr-1">{{$t('onboarding.need_help')}}</span>
            <a target="_blank" href="https://wallkit.net/docs" class="blue"><u>{{$t('onboarding.documentation')}}</u></a>
          </div>

          <div v-for="(resource, index) in resources" class="w-100 py-2 px-md-3 px-0">

            <h5 class="text-primary text-center mb-0">{{resource.title}}</h5>

            <div class="w-100 text-primary">
              <label for="public_key">{{$t(`resources.public_key`)}}</label>
              <b-input-group class="w-100 mb-2 d-flex flex-nowrap">
                <b-form-input
                  class="w-100 rounded-10-left"
                  readonly
                  v-model="resources[index].public_key"
                  id="public_key">
                </b-form-input>
                <b-btn
                  id="copyButton1"
                  @click="copyText('public_key')"
                  variant="light"
                  size="sm"
                  class="input-height rounded-10-right">
                  <i class="far fa-copy fa-2x text-muted"></i>
                </b-btn>
              </b-input-group>
              <b-tooltip
                target="copyButton1"
                triggers="focus"
                :title="$t('onboarding.key_copied')"
                placement="topright"
                :delay="{show: 0, hide: 800}"
              ></b-tooltip>
            </div>

            <div class="w-100 text-primary ">
              <label for="secret_key">{{$t(`resources.secret_key`)}}</label>
              <b-input-group class="w-100 mb-2 d-flex flex-nowrap">
                <b-form-input
                  class="w-100 rounded-10-left"
                  readonly
                  v-model="resources[index].secret_key"
                  id="secret_key"></b-form-input>
                <b-btn
                  id="copyButton2"
                  @click="copyText('secret_key')"
                  variant="light"
                  size="sm"
                  class="input-height rounded-10-right">
                  <i class="far fa-copy fa-2x text-muted"></i>
                </b-btn>
              </b-input-group>
              <b-tooltip
                target="copyButton2"
                triggers="focus"
                :title="$t('onboarding.key_copied')"
                placement="topright"
                :delay="{show: 0, hide: 800}"
              ></b-tooltip>
            </div>

          </div>
        </div>

        <div v-if="type === 'wordpress'" class="mb-3 mt-2">
          <span class="text-primary mr-1">{{$t('onboarding.website_options.also_check_out')}}</span>
          <a target="_blank" href="https://docs.google.com/document/d/1yStRHp2_w7eAxPBmVBurjvH1MVMZM42qmDeCAuQ9K-s"
             class="blue"><u>{{$t('onboarding.website_options.wordpress_link')}}</u></a>
        </div>

        <p class="text-primary text-center small" v-html="$t('onboarding.note')"></p>

      </div>

      <div class="bg-light text-primary text-center py-3 w-100 rounded mb-3">
        <h3 class="font-weight-light">{{$t('onboarding.next')}}</h3>
        <span class="small" v-html="$t('onboarding.next_text')"></span>
        <router-link class="ml-1 blue small" :to="{path: '/plans'}"><u>{{$t('onboarding.next_link')}}</u></router-link>
      </div>


      <div class="d-flex justify-content-between w-100">
        <router-link :to="{path: '/setup-step2'}" class="d-none d-sm-block">
          <b-btn variant="link" size="sm">
            <b><< </b><u>{{$t('button.back')}}</u>
          </b-btn>
        </router-link>
        <router-link :to="{path: '/'}">
          <b-btn variant="link" size="sm">
            <u>{{$t('onboarding.close_modal')}}</u>
          </b-btn>
        </router-link>
      </div>
    </template>
  </onboardingModal>
</template>

<script>
  import onboardingModal from './onboardingModal.vue'

  export default {
    name: "setupStep3",
    components: {
      onboardingModal
    },
    created() {
      if (!this.$route.params.type) {
        this.$router.replace({path: '/setup-step2'})
      }
    },
    computed: {
      type() {
        return this.$route.params.type
      },
      resources() {
        return this.$store.getters['resource/createdResources']
        // return [
        //   {
        //     title: 'Wallkit',
        //     public_key: 'awrgewegwegwegweg',
        //     secret_key: 'awrgewegwegwegweg'
        //   }
        // ]
      }
    },
    // async destroyed() {
    //   try {
    //     await this.$store.dispatch('resource/fetchResources');
    //     await this.$store.dispatch('resource/setDefaultResource');
    //   }
    //   catch (err) {
    //     console.error(err.response.data);
    //   }
    //
    // }
  }
</script>